module.exports = __webpack_public_path__ + "media/images/voice03-a131a3dc2bb027fe9a1f832733f3bff6.jpg";